import { render } from "./Dermatology.vue?vue&type=template&id=333b6188&scoped=true"
import script from "./Dermatology.vue?vue&type=script&lang=ts"
export * from "./Dermatology.vue?vue&type=script&lang=ts"

import "./Dermatology.vue?vue&type=style&index=0&id=333b6188&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-333b6188"

export default script